import type { DcrAttachment as ServerDcrAttachment } from '@/core/graphql/generated/types';
import type { DcrAttachment } from '@/features/DataChangeRequest/_types/attachment';

export const toLocalAttachments = (
	serverAttachments: ServerDcrAttachment[] | null | undefined
): DcrAttachment[] =>
	(serverAttachments ?? []).map(a => ({
		id: a.id,
		name: a.fileName,
		size: a.fileSize,
		mimeType: a.fileContentType,
		previewUrl: a.viewUrl,
		status: 'success',
		progress: 100,
		remoteId: a.id
	}));
